import axios from 'api/axios'
import { useState } from 'react'

const useCloseExpedient = (tipo_expediente, numero_expediente) => {
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState(null)

  const cerrarExpediente = async () => {
    try {
      setLoading(true)

      const response = await axios.put(`/expedienteslisa/${numero_expediente}/`, {
        expediente: {
          tipo_expediente: tipo_expediente,
          numero_expediente: numero_expediente,
        },
      })

      setResponse(response.data)
    } catch (error) {
      // Error handled
    } finally {
      setLoading(false)
    }
  }

  return { cerrarExpediente, loading, response }
}

export default useCloseExpedient
